MemberState = require 'view-models/member-state'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/member_cards_sort'
track = require 'debug/track'

module.exports = class MemberCardsSortPopOverView extends View
  viewTitleKey: 'sort cards'

  initialize: ->
    @listenTo MemberState, 'change:cardsPageSortType', ->
      @render()

  events:
    'click .js-sort-by-board': 'sortByBoard'
    'click .js-sort-by-due-date': 'sortByDueDate'

  render: ->
    @$el.html(template({
      sort: MemberState.getCardsPageSortType()
    }))

    @

  sortByBoard: (e) ->
    Util.stop(e)
    MemberState.sortCardsPageByBoard()
    PopOver.hide()
    track("Member View", "Cards Page", "Sort by Board")
    return

  sortByDueDate: (e) ->
    Util.stop(e)
    MemberState.sortCardsPageByDate()
    PopOver.hide()
    track("Member View", "Cards Page", "Sort by Due Date")
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-sort-pop-over-view.coffee